import { gql } from "@apollo/client";

export const shopProducts = gql`
  query query {
    products(first: 20) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          title
          description
          descriptionHtml
          options {
            id
            name
            values
          }
          variants(first: 250) {
            pageInfo {
              hasNextPage
              hasPreviousPage
            }
            edges {
              node {
                id
                title
                selectedOptions {
                  name
                  value
                }
                image {
                  id
                  height
                  width
                  url
                  altText
                }
                price {
                  ... on MoneyV2 {
                    amount
                    currencyCode
                  }
                }
                metafields(
                  identifiers: [{ namespace: "custom", key: "description" }]
                ) {
                  key
                  value
                }
              }
            }
          }
          images(first: 250) {
            pageInfo {
              hasNextPage
              hasPreviousPage
            }
            edges {
              node {
                id
                height
                width
                url
                altText
              }
            }
          }
        }
      }
    }
  }
`;
